<template>
    <div class="sub-layout">
        <div class="sub_toptit">
            <h1>E-Poster</h1>
        </div>

        <div class="contentBox">
            <div class="sub_container">
                <div class="agul mb3rem">
                    <ul>
                        <li>Only pre-registrants can view the content.</li>
                        <li>The KOREADERMA {{ event_code }} E-poster platform has been optimized for Chrome and Explorer.</li>
                        <li>Any capturing, sharing, and (or) distributing of the E-poster is strictly prohibited.</li>
                        <li>You can view a corresponding E-poster if clinking each E-poster title.</li>
                        <li>When an E-poster window opens, please use the left and right direction buttons on the screen.</li>
                    </ul>
                </div>

                <div class="postertable">
                    <DataTable 
                        :value="dataList" 
                        :paginator="dataList.length > 0" 
                        :rows="20"
                        :first="first"
                        @page="onPageChange"
                        tableStyle="min-width: 50rem" 
                        class="custom_table"
                    >
                        <Column field="rownum" header="No." style="width: 40px;"></Column>
                        <Column field="topic" header="Topic"></Column>
                        <Column field="title" header="Title">
                            <template #body="slotProps">
                                <a class="pdfview" href="javascript:void(0)" @click="openModal(slotProps.data)">{{ slotProps.data.title }}</a>
                            </template>
                        </Column>
                        <Column field="name" header="Name"></Column>
                        <Column field="affiliation" header="Affiliation"></Column>
                        <Column field="email" header="E-mail"></Column>
                    </DataTable>
                </div>
            </div>
        </div>

        <!-- PDF 뷰어 모달 -->
        <Dialog 
            v-model:visible="pdfviewView" 
            header=" " 
            modal 
            class="custom-dialog" 
            :style="{ width: '50vw' }"
            :breakpoints="{ '1500px': '50vw', '991px': '60vw', '580px': '90vw' }"
            @hide="resetPage"

        >
            <div v-if="pdfSource != ''" class="pdfviewer" >
                <PdfEmbed
                    style="width: 100%; "
                    :source="pdfSource" 
                    :page="currentPage" 
                    @loaded="onPdfLoaded"
                />
            </div>
            <div v-else class="pdfviewer" >
                <div style="padding: 20px;">TBU</div>
            </div>
            <div class="footer">
                <button @click="prevPage" :disabled="currentPage <= 1"><i class="pi pi-angle-up"></i></button>
                <button @click="nextPage" :disabled="currentPage >= totalPages"><i class="pi pi-angle-down"></i></button>
                <span>Page {{ currentPage }} / {{ totalPages }}</span>
            </div>
        </Dialog>
    </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';   // optional
import Row from 'primevue/row';                   // optional
import Dialog from 'primevue/dialog';
import PdfEmbed from 'vue-pdf-embed'; // https://www.npmjs.com/package/vue-pdf-embed
import 'vue-pdf-embed/dist/styles/annotationLayer.css'
import 'vue-pdf-embed/dist/styles/textLayer.css'
import { supabase } from '@/API/supabase';

export default {
    name: 'E-Poster',
    data() {
        return {
            dataList: [],
            pdfviewView: false,
            pdfSource: '', // 초기 PDF 임시 경로
            currentPage: 1,
            totalPages: 0,  // 총 페이지 수
            first: 0,
            event_code: '',
        };
    },
    components: {
        DataTable,
        Column,
        ColumnGroup,
        Row,
        Dialog,
        PdfEmbed,
    },
    async mounted() {

        this.event_code = await this.getEventCode();
        this.getList();

    },
    methods: {

        // 이벤트 코드 가져오기
        async getEventCode() {
            let query = supabase
                .from('Event')
                .select('*')
                .eq('active', true)
                .order('event_code', { ascending: false })
                .limit(1)
                .single();

            const { data, error } = await query;

            // console.log(data);
            if(data){
                return data.event_code;
            }else{
                return new Date().getFullYear().toString();
            }
        },

        // E-Poster 리스트 가져오기
        async getList() {
            const { data, error } = await supabase.rpc('get_lectures_for_eposter', 
                { pm_event_code: this.event_code });

            if (error) {
                console.log('error', error);
            } else {
                // console.log("eposterList :", data);
                var eposterList = [];
                for (var i = 0; i < data.length; i++) {
                    var item = data[i];
                    if(item.eposter_file){
                        item.eposter_url = await this.downloadFile(item.useruid, item.lecture_id);
                    }else{
                        item.eposter_url = '';
                    }

                    eposterList.push({
                        rownum: i + 1,
                        topic: item.topic,
                        title: item.title,
                        name: item.name,
                        affiliation: item.affiliation,
                        email: item.email,
                        eposter_file: item.eposter_file,
                        eposter_url: item.eposter_url,
                    });
                }

                this.dataList = eposterList;
            }
        },

        // 파일 다운로드
        async downloadFile(useruid, lecture_id) {
            const { data, error } = await supabase.storage.from('eposter').download(`${useruid}_${lecture_id}`);

            if (error) {
                console.error(error);
                return;
            } else {
                // console.log(data);
                
                const blobUrl = URL.createObjectURL(data);
                return blobUrl; // <img> 태그에 적용
            }
        },

        openModal(data) {
            if(data.eposter_file.includes('pdf')){
                this.pdfSource = data.eposter_url; // PDF 경로 설정
                
            }else{
                this.pdfSource = '';
            }
            this.pdfviewView = true;

        },
        resetPage() {
            this.currentPage = 1;
        },

        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage -= 1;
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage += 1;
            }
        },
        onPdfLoaded(pdf) {
            this.totalPages = pdf.numPages;
        },

        // 페이지 변경
        onPageChange(event) {
            this.first = event.first;
        },

    },
};
</script>
<style>
.pdfviewer{
    width: 100%;
    overflow: auto;
}

</style>